module.exports = __webpack_public_path__ + "img/Unicom-1.b2e12fba.svg";